import { CycleUtils, UrlUtils } from '@wix/package-picker-shared';
import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const PackagePickerStoreExtension = ModuleExtensions.storeExtension({
  selectedProductId: null,
  selectedCycleId: null
}, 'PackagePickerStore', {
  useSelectedProductId: state => {
    return state.selectedProductId;
  },
  useSelectedCycleId: state => {
    return state.selectedCycleId;
  },
  useSelectedCycle: state => {
    return CycleUtils.convertCycleIdToCycle(state.selectedCycleId);
  }
}, {
  setSelectedProductId: (_ref, newSelectedProductId) => {
    let {
      draft
    } = _ref;
    draft.selectedProductId = newSelectedProductId;
    UrlUtils.replaceSearchParam('productId', newSelectedProductId);
  },
  setSelectedCycleId: (_ref2, newSelectedCycleId) => {
    let {
      draft
    } = _ref2;
    draft.selectedCycleId = newSelectedCycleId;
    UrlUtils.replaceSearchParam('cycleId', newSelectedCycleId);
  }
});
//# sourceMappingURL=packagePickerStore.extension.js.map